// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import "./customStyles.css";
// import Logo1 from "../images/logo/ibi.png";

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./customStyles.css";
import Logo1 from "../../images/logo/ibi.png";
import { Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
const tracks = {
  "Data Engineer": [
    { name: "Linux", weeks: 2 },
    { name: "Git and GitHub", weeks: 1 },
    { name: "AWS (Data Engineer Services)", weeks: 2 },
    { name: "Azure (Data Engineer Services)", weeks: 2 },
    { name: "GCP (Data Engineer Services)", weeks: 2 },
    { name: "Pandas + Numpy + Matplotlib + Seaborn", weeks: 3 },
    { name: "Data Warehouse Concepts", weeks: 3 },
    { name: "Excel", weeks: 1 },
    { name: "Power BI", weeks: 6 },
    { name: "Oracle SQL", weeks: 6 },
    { name: "Python", weeks: 6 },
    { name: "Programming Fundamentals and Data Structure", weeks: 6 },
  ],
  "UI/UX - Figma": [
    { name: "UX Research", weeks: 8 },
    { name: "iOS Design", weeks: 7 },
    { name: "Android Design", weeks: 5 },
    { name: "Website", weeks: 4 },
    { name: "Protfolio ios,android,website ", weeks: 1 },
    { name: "Usecase study", weeks: 1 },
    { name: "Other tools support design ", weeks: 1 },
  ],
  "Full Stack - MERN": [
    { name: "MongoDB", weeks: 6 },
    { name: "Express.js", weeks: 6 },
    { name: "React", weeks: 6 },
    { name: "Node.js", weeks: 6 },
  ],
  "Full Stack - Java": [
    { name: "Spring Boot", weeks: 8 },
    { name: "MySQL", weeks: 7 },
    { name: "React/Angular", weeks: 7 },
  ],
  "Full Stack - MEAN": [
    { name: "MongoDB", weeks: 8 },
    { name: "Express.js", weeks: 8 },
    { name: "Angular", weeks: 8 },
    { name: "Node.js", weeks: 8 },
  ],
  "Full Stack - Python": [
    { name: "Python", weeks: 8 },
    { name: "Django", weeks: 7 },
    { name: "Flask", weeks: 5 },
    { name: "MySQL", weeks: 4 },
  ],
  "Back-End Development": [
    { name: "Node.js", weeks: 8 },
    { name: "Express.js", weeks: 8 },
    { name: "REST API", weeks: 8 },
    { name: "SQL", weeks: 6 },
    { name: "MongoDB", weeks: 8 },
    { name: "Java", weeks: 7 },
    { name: "Spring Boot", weeks: 8 },
    { name: "Hibernate", weeks: 8 },
    { name: "MySQL", weeks: 4 },
    { name: "Python", weeks: 8 },
    { name: "Django", weeks: 7 },
    { name: "PostgreSQL", weeks: 4 },
  ],
  "Front-End Development": [
    { name: "HTML5", weeks: 8 },
    { name: "CSS3", weeks: 7 },
    { name: "JavaScript", weeks: 5 },
    { name: "React.js", weeks: 4 },
    { name: "Git", weeks: 4 },
    { name: "TailwindCSS", weeks: 4 },
  ],
  "Dev Ops": [
    { name: "Linux", weeks: 4 },
    { name: "Git", weeks: 2 },
    { name: "GitHub", weeks: 2 },
    { name: "GitHub Actions", weeks: 2 },
    { name: "Docker", weeks: 4 },
    { name: "Kubernetes", weeks: 4 },
    { name: "Ansible", weeks: 3 },
    { name: "Prometheus", weeks: 2 },
    { name: "Grafana", weeks: 2 },
    { name: "Shell Scripting", weeks: 3 },
    { name: "Jenkins", weeks: 3 },
    { name: "CI/CD Stack", weeks: 4 },
    { name: "Cloud DevOps Stack", weeks: 4 },
    { name: "Containerization Stack", weeks: 4 },
  ],

  "LLM & Generative AI": [
    {
      Beginner: [
        { name: "NLP", weeks: 3 },
        { name: "Transformers Demystified", weeks: 3 },
        { name: "BERT & GPT", weeks: 3 },
      ],
    },
    {
      Intermediate: [
        { name: "Hugging Face", weeks: 3 },
        { name: "Prompt Engineering", weeks: 2 },
        { name: "LLMs", weeks: 3 },
      ],
    },
    {
      Advanced: [
        { name: "Chatbot Development", weeks: 3 },
        { name: "RAG & LangChain", weeks: 4 },
        { name: "Capstone", weeks: 6 },
      ],
    },
  ],
  "Machine Learning": [
    {
      Beginner: [
        { name: "Introduction", weeks: 2 },
        { name: "Models", weeks: 3 },
        { name: "ML with Scikit", weeks: 4 },
      ],
    },
    {
      Intemidiate: [
        { name: "Engineering Toolkit", weeks: 3 },
        { name: "Model Evaluation & Tuning", weeks: 3 },
        { name: "Ensemble Models", weeks: 3 },
      ],
    },
    {
      Advanced: [
        { name: "TensorFlow", weeks: 4 },
        { name: "Computer Vision", weeks: 4 },
        { name: "NLP", weeks: 4 },
        { name: "Capstone", weeks: 6 },
      ],
    },
  ],
  "Data Science": [
    {
      Beginner: [
        { name: "Data Science Essentials", weeks: 3 },
        { name: "Python", weeks: 4 },
        { name: "Statistics & Probability for DS", weeks: 3 },
        { name: "Data Visualization Master Class", weeks: 3 },
      ],
    },
    {
      Intemidiate: [
        { name: "SQL", weeks: 3 },
        { name: "EDA", weeks: 3 },
        { name: "Time Series Forecasting", weeks: 4 },
        { name: "Data Storytelling", weeks: 2 },
        { name: "Dashboards", weeks: 3 },
      ],
    },
    {
      Advanced: [
        { name: "Predictive Modeling", weeks: 4 },
        { name: "Capstone", weeks: 6 },
      ],
    },
  ],
};

const AppF = () => {
  const [selectedTrack, setSelectedTrack] = useState("Data Engineer");
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    mode: "",
    date: "",
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedLevels, setSelectedLevels] = useState([]);
  const formRef = useRef(null);
  const [showFooter, setShowFooter] = useState(false);
  const topRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // if form is fully visible -> hide footer
        if (entries[0].isIntersecting) {
          setShowFooter(false);
        } else {
          setShowFooter(true);
        }
      },
      { threshold: 1.0 } // 1.0 = fully visible
    );

    if (formRef.current) {
      observer.observe(formRef.current);
    }

    return () => {
      if (formRef.current) {
        observer.unobserve(formRef.current);
      }
    };
  }, []);

  const scrollToTopSection = () => {
    if (topRef.current) {
      const yOffset = -80; // adjust this based on your navbar height
      const y =
        topRef.current.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const handleAddCourse = (course) => {
    if (
      !selectedCourses.find(
        (c) => c.name === course.name && c.track === selectedTrack
      )
    ) {
      // ✅ If the course with the same track doesn’t exist, add it
      setSelectedCourses([
        ...selectedCourses,
        { ...course, track: selectedTrack },
      ]);
    }
  };

  const handleRemoveCourse = (name, track) => {
    setSelectedCourses(
      selectedCourses.filter((c) => !(c.name === name && c.track === track))
    );
  };

  const handleAddLevel = ({ track, level, courses }) => {
    const alreadyAdded = selectedLevels.some(
      (sl) => sl.track === track && sl.level === level
    );

    if (!alreadyAdded) {
      setSelectedLevels([...selectedLevels, { track, level, courses }]);
    }
  };

  const handleRemoveLevel = (track, level) => {
    setSelectedLevels(
      selectedLevels.filter((sl) => !(sl.track === track && sl.level === level))
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Validation checks before sending
    if (!form.name.trim()) {
      alert("⚠️ Please enter your name.");
      return;
    }

    if (!form.mode) {
      alert("⚠️ Please select a preferred mode.");
      return;
    }

    if (!form.date) {
      alert("⚠️ Please select a joining date.");
      return;
    }

    if (!form.phone || !/^\d{10}$/.test(form.phone)) {
      alert("⚠️ Please enter a valid 10-digit phone number.");
      return;
    }

    if (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      alert("⚠️ Please enter a valid email address.");
      return;
    }

    // 🔒 Require at least one course or level
    if (selectedCourses.length === 0 && selectedLevels.length === 0) {
      alert("⚠️ Please select at least one course or level before submitting.");
      return;
    }

    setLoading(true);

    const payload = {
      Selected_Courses: [
        ...selectedCourses.map(
          (c) => `${c.track} → ${c.name} (${c.weeks} weeks)`
        ),
        ...selectedLevels.map(
          (sl) =>
            `${sl.track} → ${sl.level} (${sl.courses.reduce(
              (acc, c) => acc + c.weeks,
              0
            )} weeks)`
        ),
      ].join(", "),
      Phone_Number: form.phone,
      Student_Name: form.name,
      Student_Email: form.email,
      Preferred_Mode: form.mode,
      Your_preferred_joining_date: form.date,
    };

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbwrLBVUPNtNjw-lK5UG95AIaNxLUzFefLx3xZm39qSIq1SGNFoTE7GV2kEYPrigXTmi7A/exec",
        {
          method: "POST",
          mode: "no-cors", // 🚨 prevents CORS error
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(payload).toString(),
        }
      );

      // pretend success (since no response is available)
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);

      // reset form
      setSelectedCourses([]);
      setSelectedLevels([]);
      setForm({ name: "", email: "", phone: "", mode: "", date: "" });
    } catch (err) {
      alert("Submission failed.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const onWheel = (e) => {
      if (e.deltaY === 0) return; // ignore if no vertical scroll
      e.preventDefault();
      el.scrollLeft += e.deltaY; // turn vertical scroll into horizontal
    };

    el.addEventListener("wheel", onWheel, { passive: false });
    return () => el.removeEventListener("wheel", onWheel);
  }, []);

  // ======
  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -200 : 200,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          {/* Logo */}
          <img src={Logo1} className="navbar-logo" alt="" />
          <Typography variant="h6" noWrap>
            <Link
              to="/sign-in"
              style={{
                color: "#003399",
                padding: "6px 16px",

                textDecoration: "none",
                // display: "inline-block",
              }}
            >
              Login
            </Link>
          </Typography>
        </div>
      </nav>

      <div className="learning-path-container">
        <div className="lp-grid">
          {/* Left Section: Track Buttons + Available Courses */}
          <div className="left-section">
            {/* Track Buttons */}
            <div className="fade-edges track-buttons" ref={topRef}>
              <div className="track-buttons-scroll" ref={scrollRef}>
                <div className="track-buttons-row">
                  {Object.keys(tracks).map((track) => (
                    <button
                      key={track}
                      onClick={() => setSelectedTrack(track)}
                      className={`track-btn${
                        selectedTrack === track ? " selected" : ""
                      }`}
                    >
                      {track}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="scroll-controls">
              <button className="scroll-btn" onClick={() => scroll("left")}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <rect width="32" height="32" fill="none" />
                  <polyline
                    points="160 208 80 128 160 48"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  />
                </svg>
              </button>
              <button className="scroll-btn" onClick={() => scroll("right")}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <rect width="32" height="32" fill="none" />
                  <polyline
                    points="96 48 176 128 96 208"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="24"
                  />
                </svg>
              </button>
            </div>

            {/* Available Courses */}
            <div>
              <h2
                className="heading-main"
                style={{ fontSize: "1.25rem", marginBottom: "1rem" }}
              >
                Build your own learning path by picking courses from below.{" "}
              </h2>
              <h2
                className="heading-mobile"
                style={{ fontSize: "1.25rem", marginBottom: "1rem" }}
              >
                Choose courses from below.
              </h2>
              <div className="fade-vertical">
                <div className="courses-scroll-container custom-scrollbar">
                  <div className="available-courses-grid">
                    {Array.isArray(tracks[selectedTrack]) &&
                    tracks[selectedTrack].length > 0 &&
                    typeof tracks[selectedTrack][0] === "object" &&
                    !("name" in tracks[selectedTrack][0])
                      ? tracks[selectedTrack].map((levelObj) => {
                          const levelName = Object.keys(levelObj)[0];
                          const courses = levelObj[levelName];

                          // ✅ Check only if THIS level is already added
                          const isLevelAdded = selectedLevels.some(
                            (sl) =>
                              sl.track === selectedTrack &&
                              sl.level === levelName
                          );

                          return (
                            <div
                              key={levelName}
                              className={`level-course-card ${
                                isLevelAdded ? "added" : ""
                              }`}
                            >
                              <h3 className="level-title">
                                {selectedTrack}{" "}
                                <span className="level-sub">({levelName})</span>
                              </h3>

                              <ul className="level-ul">
                                {courses.map((course) => (
                                  <li key={course.name}>{course.name}</li>
                                ))}
                              </ul>

                              <button
                                onClick={() =>
                                  handleAddLevel({
                                    track: selectedTrack,
                                    level: levelName,
                                    courses,
                                  })
                                }
                                disabled={isLevelAdded}
                                className={`level-add-btn ${
                                  isLevelAdded ? "added" : ""
                                }`}
                              >
                                {isLevelAdded ? "✓ Added to Program" : "Add"}
                              </button>
                            </div>
                          );
                        })
                      : tracks[selectedTrack].map((course) => {
                          const isAdded = selectedCourses.some(
                            (c) =>
                              c.name === course.name &&
                              c.track === selectedTrack
                          );
                          return (
                            <div
                              key={course.name}
                              className={`course-card${
                                isAdded ? " added" : ""
                              }`}
                            >
                              <h3 className="course-title">{course.name}</h3>
                              <button
                                className={`add-btn${isAdded ? " added" : ""}`}
                                disabled={isAdded}
                                onClick={() =>
                                  handleAddCourse({
                                    ...course,
                                    track: selectedTrack,
                                  })
                                }
                              >
                                {isAdded ? "✓ Added to Program" : "Add"}
                              </button>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Right Section: My Custom Program */}
          <div className="right-section">
            <div className="program-header">
              <h2 className="program-title">📌 My Custom Program</h2>
              <p className="program-count-label">
                Selected Course{" "}
                <span className="program-selected-count">
                  ({selectedCourses.length + selectedLevels.length})
                </span>
              </p>
            </div>

            <div className="selected-courses-list">
              {/* Normal Courses */}
              {selectedCourses.map((course) => (
                <div
                  key={`${course.track}-${course.name}`}
                  className="selected-course-entry"
                >
                  <span>
                    <strong>{course.track}</strong> → {course.name}
                  </span>
                  <button
                    onClick={() =>
                      handleRemoveCourse(course.name, course.track)
                    }
                    className="remove-btn"
                  >
                    ×
                  </button>
                </div>
              ))}

              {/* Level Courses */}
              {selectedLevels.map((level) => (
                <div
                  key={`${level.track}-${level.level}`}
                  className="selected-course-entry"
                >
                  <span>
                    <strong>{level.track}</strong> → {level.level}
                  </span>
                  <button
                    onClick={() => handleRemoveLevel(level.track, level.level)}
                    className="remove-btn"
                  >
                    ×
                  </button>
                </div>
              ))}

              {/* Empty State */}
              {selectedCourses.length === 0 && selectedLevels.length === 0 && (
                <>
                  <p className="empty-text desktop-only">
                    No courses added yet.
                  </p>
                  <p
                    className="click-to-add mobile-only"
                    onClick={scrollToTopSection}
                  >
                    Click to add a course
                  </p>
                </>
              )}
            </div>

            <div className="program-divider"></div>
            <form
              ref={formRef}
              onSubmit={handleSubmit}
              className="program-form"
            >
              {/* Name */}
              <label>Your Name</label>
              <input
                type="text"
                placeholder="Enter your name..."
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
              />

              <div className="form-row">
                {/* Mode */}
                <div className="form-col">
                  <label>Preferred Mode</label>
                  <div className="mode-options">
                    <label>
                      <input
                        type="radio"
                        name="mode"
                        value="Online"
                        checked={form.mode === "Online"}
                        onChange={(e) =>
                          setForm({ ...form, mode: e.target.value })
                        }
                        required
                      />
                      Online
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="mode"
                        value="Offline"
                        checked={form.mode === "Offline"}
                        onChange={(e) =>
                          setForm({ ...form, mode: e.target.value })
                        }
                      />
                      Offline
                    </label>
                  </div>
                </div>

                {/* Date */}
                <div className="form-col">
                  <label>Your Preferred Joining Date?</label>
                  <input
                    type="date"
                    value={form.date}
                    onChange={(e) => setForm({ ...form, date: e.target.value })}
                    required
                  />
                </div>
              </div>

              {/* Phone */}
              <label>Phone Number</label>
              <input
                type="tel" // <-- changed from number to tel (better for validation)
                placeholder="Enter 10 digit Phone Number..."
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                required
              />

              {/* Email */}
              <label>Email for Offer Updates</label>
              <input
                type="email"
                placeholder="Enter your email..."
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
              />

              <button
                type="submit"
                className="submit-btn"
                disabled={
                  loading ||
                  (selectedCourses.length === 0 && selectedLevels.length === 0)
                }
              >
                {loading ? "Sending..." : "Register Your Spot & Offers"}
              </button>
            </form>

            {/* floating navbar */}
            <div>
              {showFooter && (
                <button onClick={scrollToForm} className="floating-footer">
                  Register Your Spot & Offers
                </button>
              )}
            </div>
            {/* Success Popup */}
            {showSuccess && (
              <div className="popup-bg">
                <div className="popup-card">
                  <span className="popup-check">✓</span>
                  <h2 className="popup-title">Program Submitted!</h2>
                  <p className="popup-message">
                    You'll receive an email with updates or offers.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AppF;
